<template>
  <div class="overlay">
    <div class="form-wrapper">
      <a href="http://piknik.cc" target="_blank">
        <v-img
          class="logo mb-8"
          max-width="100px"
          src="../assets/piknik-logo-white.svg"
          alt="Piknik"
        />
      </a>
      <h2 class="white--text mb-2">{{ $t("forgotPasswordTitle") }}</h2>
      <p class="white--text mb-8">{{ $t("forgotPasswordDescription") }}</p>
      <v-form ref="form" v-model="valid">
        <v-text-field
          dark
          v-model="email"
          :rules="[rules.required, rules.email]"
          :label="$t('email')"
          type="email"
          rounded
          dense
          filled
        ></v-text-field>
        <v-btn
          v-on:click="forgotPassword"
          dark
          color="white"
          depressed
          rounded
          :disabled="!valid || snackbar"
          :loading="loading"
          >{{ $t("recoverPassword") }}</v-btn
        >
      </v-form>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackbarText }}
      <!-- <v-btn text small rounded @click="reload()" color="white"
        >Ok</v-btn
      > -->
    </v-snackbar>
  </div>
</template>

<script>
import userService from "../services/user.service";

export default {
  data() {
    return {
      drawer: null,
      valid: true,
      rules: {
        required: (value) => !!value || this.$t("requiredField"),
        email: (v) => /.+@.+\..+/.test(v) || this.$t("emailMustBeCorrect"),
      },
      email: "",
      loading: false,
      snackbar: false,
      snackbarText: this.$t("ifAccountExistsWeHaveSentRecoveryEmail"),
      timeout: 0,
    };
  },
  methods: {
    async forgotPassword() {
      this.loading = true;
      const resp = await userService.forgotPassword(this.email);
      this.loading = false;
      this.snackbar = true;
    },
    // reload() {
    //   this.email = "";
    //   this.snackbar = false;
    // },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #007bff;
  z-index: 10;
  display: flex;
  align-items: center;
  text-align: center;
}

.form-wrapper {
  width: 350px;
  height: auto;
  margin: 0 auto;
}

.form-wrapper .logo {
  margin: 0 auto;
}

@media (max-width: 600px) {
  .form-wrapper {
    padding: 32px;
  }
}

/deep/ .v-input__slot {
  background: rgba(255, 255, 255, 0.2) !important;
}

.form-wrapper /deep/ .v-btn {
  width: 100%;
}

/deep/ .v-btn {
  color: #007bff !important;
}

/deep/ .v-application .error--text {
  color: black !important;
  caret-color: black !important;
}

@media only screen and (max-width: 599px) {
  .overlay {
    overflow-y: scroll;
    text-align: start;
    align-items: flex-start;
    padding-top: 32px;
  }

  .overlay::-webkit-scrollbar {
    display: none;
  }

  .overlay {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .form-wrapper {
    width: 100%;
  }

  .form-wrapper .logo {
    margin: 0;
  }
}
</style>